import React, { useEffect, useState } from 'react';
import { ReactComponent as LeftArrow } from 'icons/left-arrow.svg';
import { ReactComponent as WithDriverIcon } from 'icons/with-driver-filled-icon.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BookingZone, Button, InputField, TableWrapper } from 'components/Global';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerData } from 'features/user/slice';
import countryCodes from 'utils/country-codes.json';
import ActionButtons from './action-buttons';
import clsx from 'clsx';
import DetailPenyewa from './detail-penyewa';
import DetailSewa from './detail-sewa';
import DetailDeposit from './detail-deposit';
import RincianBiaya from './rincian-biaya';
import Pembayaran from './pembayaran';
import { useAppContext } from 'components/Context/AppContext';
import {
  changeOrderStatus,
  changePaymentType,
  fetchOrderByIdWithApproval,
  getOrderAddOnsById,
} from 'features/orders/actions';
import { getDetailAccountBank } from 'features/banks/actions';
import { downloadOrderDetail } from 'features/order-detail-pdf/actions';
import DetailVoucher from './detail-voucher';
import { checkEmptyObject } from 'utils/functionality';
import Tabs, { TabPane } from 'components/Global/Tabs';
import InputViolation from 'components/Global/InputViolation';
import InputAdditionals from 'components/Global/InputAdditionals';
import { getPaymentMethodString } from 'utils/getPaymentMethod';
import ReactDOM from 'react-dom';
import PriceDifferenceModal from 'components/Modals/PriceDifferenceModal';
import { getPaymentMethods } from 'features/payment/actions';
import AddOnsField from 'components/Global/AddOnsField';
import { updateApprovalStatus } from 'features/approvals/actions';
import { trackEvent } from 'utils/analytics';
import { ReactComponent as Star } from 'icons/star.svg';
import { getReviewByOrder } from 'features/reviews/actions';
import DetailPemesanan from './detail-pemesanan';
import { getConfig } from 'config/runtime';
import DetailPartner from './detail-partner';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';
import { getRentalLocationById } from 'features/rental-location/actions';

const IMAGE_BASE_URL = getConfig('REACT_APP_IMAGES');

const RenderedProcessButton = ({ data, paymentMethod, customer, isPaymentValid, handleProcess }) => {
  const isOrderApproval = data?.approval !== null;
  const isManualTransfer =
    paymentMethod?.find(
      (item) =>
        item.id ===
        (isOrderApproval
          ? data?.approval?.data?.disbursement?.payment_method_id
          : data?.disbursement?.payment_method_id),
    )?.method === 'Manual Transfer';
  const showButtonForConfirmation =
    isManualTransfer &&
    data.order_status === 'CHECKOUT' &&
    data?.order_approval_status !== 'WAITING_APPROVAL_DELETE_ORDER';
  const showButtonForUnprocess =
    (data.order_status === 'PAID' || data.order_status === 'REVIEWING_IDENTITY') &&
    !customer?.PersonalInfos?.need_review_sim &&
    !customer?.PersonalInfos?.need_review_ktp &&
    !data.order_approval_status;

  if (showButtonForConfirmation) {
    return (
      <Button
        variant="success"
        className={clsx('button', !isPaymentValid && 'button--disabled')}
        width={208}
        size="sm"
        disabled={!isPaymentValid}
        onClick={handleProcess}
      >
        Proses
      </Button>
    );
  } else if (showButtonForUnprocess) {
    return (
      <Button variant="success" className="button" width={208} size="sm" onClick={handleProcess}>
        Proses
      </Button>
    );
  } else {
    return null;
  }
};

const DetailOrder = ({
  orderData: data,
  getFileName,
  imagePreviewHandler,
  isPaymentValid,
  setShowBankTransferConfirmation,
  transactionKey,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const { setShowConfirmation, showToast } = useAppContext();

  const customer = useSelector(getCustomerData);
  const customerAccountBank = useSelector((state) => state.banks?.detailAccountBank ?? {});
  const paymentMethod = useSelector((state) => state.payment.data);
  const addOnsOrder = useSelector((state) => state.detailOrder.addOns);
  const review = useSelector((state) => state.reviews.byOrder);
  const rentalLocation = useSelector((state) => state.rentalLocation.selected);

  const [selectedCountry, setSelectedCountry] = useState({
    name: '',
    code: '',
  });
  const [activeTab, setActiveTab] = useState('Data Sekarang');
  // ADDITIONAL STATE
  const [additionalList, setAdditionalList] = useState([]);
  const [additionalPrice, setAdditionalPrice] = useState(0);
  // VIOLIATION STATE
  const [violationList, setViolationList] = useState([]);
  const [violationPrice, setViolationPrice] = useState(0);
  const [oldOrderData, setOldOrderData] = useState({});
  const [newOrderData, setNewOrderData] = useState({});
  const [showPriceDifference, setShowPriceDifference] = useState(false);

  const findCountryByCode = (code) => countryCodes.find((item) => item.dial_code == code);
  const customerId = searchParams.get('customerId');

  const backHandler = () => {
    navigate(-1);
  };

  const handleProcess = () => {
    let prevStatus;
    let nextStatus;
    let confirmationMessage;
    let toastSuccessMessage;
    let toastErrorMessage;

    switch (data?.order_status) {
      case 'CHECKOUT':
        prevStatus = 'CHECKOUT';
        nextStatus = 'PAID';
        confirmationMessage = 'Apakah anda yakin ingin mengkonfirmasi transaksi?';
        toastSuccessMessage = 'Transaksi Berhasil Dikonfirmasi';
        toastErrorMessage = 'Transaksi Gagal Dikonfirmasi!';
        break;
      case 'PAID':
        prevStatus = 'PAID';
        nextStatus = 'COMPLETED';
        confirmationMessage =
          data.type === 'HALF'
            ? `Orderan ini menggunakan pembayaran DP ${
                data?.order_detail?.dp_rule?.formula_percentage?.value
                  ? `${data.order_detail.dp_rule.formula_percentage?.value}%`
                  : ''
              }. Sebelum melanjutkan transaksi, pastikan pelanggan telah membayar sisa DP terlebih dahulu. Tetap lanjutkan?`
            : 'Apakah anda yakin ingin memproses transaksi?';
        toastSuccessMessage = 'Transaksi Berhasil Diproses';
        toastErrorMessage = 'Transaksi Gagal Diproses!';
        break;
      case 'REVIEWING_IDENTITY':
        prevStatus = 'REVIEWING_IDENTITY';
        nextStatus = 'COMPLETED';
        confirmationMessage =
          data.type === 'HALF'
            ? `Orderan ini menggunakan pembayaran DP ${
                data?.order_detail?.dp_rule?.formula_percentage?.value
                  ? `${data.order_detail.dp_rule.formula_percentage?.value}%`
                  : ''
              }. Sebelum melanjutkan transaksi, pastikan pelanggan telah membayar sisa DP terlebih dahulu. Tetap lanjutkan?`
            : 'Apakah anda yakin ingin memproses transaksi?';
        toastSuccessMessage = 'Transaksi Berhasil Diproses';
        toastErrorMessage = 'Transaksi Gagal Diproses!';
        break;
      default:
        throw new Error('order status not found!');
    }

    const payload = {
      prevStatus,
      nextStatus,
      transaction_key: data?.transaction_key,
    };

    setShowConfirmation({
      message: confirmationMessage,
      show: true,
      onClick: async () => {
        try {
          trackEvent('order_status_advanced', {
            order_id: data?.transaction_key,
            to_status: nextStatus,
            source: 'detail_order_with_driver',
            via_approval: Boolean(data?.order_approval_status?.includes('UPDATE_ORDER')),
          });
          if (data?.order_approval_status?.includes('UPDATE_ORDER')) {
            await dispatch(updateApprovalStatus({ status: 'approved', id: data?.approval?.id, skip: true })).unwrap();
          } else {
            await dispatch(changeOrderStatus(payload)).unwrap();
          }
          showToast({ type: 'success', message: toastSuccessMessage });

          // change DP 50% to Lunas
          if (data.type === 'HALF' && data.order_status === 'PAID') {
            await dispatch(changePaymentType(data?.transaction_key)).unwrap();
          }
        } catch (err) {
          showToast({ type: 'error', message: toastErrorMessage });
        } finally {
          navigate(-1);
        }
      },
    });
  };

  useEffect(() => {
    if (!transactionKey) return;
    dispatch(fetchOrderByIdWithApproval(transactionKey));
    dispatch(getOrderAddOnsById(transactionKey));
    dispatch(getPaymentMethods());
    dispatch(getReviewByOrder(transactionKey));
  }, [transactionKey]);

  useEffect(() => {
    if (checkEmptyObject(data)) return;
    setOldOrderData(data || {});
    setNewOrderData(data?.approval?.data || {});
    dispatch(getRentalLocationById(data?.order_detail?.location_id));
  }, [data]);

  useEffect(() => {
    if (!customerId) return;

    dispatch(getDetailAccountBank(customerId));
  }, [customerId]);

  useEffect(() => {
    if (customer) {
      setSelectedCountry(findCountryByCode(data?.phone_country_code));
    }
  }, [customer, data]);

  useEffect(() => {
    if (additionalList.length > 0) {
      setAdditionalPrice(() => additionalList.map((item) => item.value).reduce((acc, cVal) => acc + cVal, 0));
      return;
    }
    setAdditionalPrice(0);
  }, [additionalList]);

  useEffect(() => {
    if (Object.prototype.hasOwnProperty.call(data, 'order_violations')) {
      if (data.order_violations !== null) {
        setViolationList(data.order_violations);
      }
    }
  }, [data]);

  useEffect(() => {
    if (violationList.length > 0) {
      setViolationPrice(() => violationList?.map((item) => item.cost).reduce((acc, cVal) => acc + cVal, 0));
      return;
    }
    setViolationPrice(0);
  }, [violationList]);

  const handleExportToPdf = async () => {
    try {
      await dispatch(downloadOrderDetail(data.transaction_key)).unwrap();
    } catch (error) {
      showToast({ type: 'error', message: 'Gagal Export ke PDF' });
    }
  };

  const isB2BPartnerIntegrationEnabled = useFliptBoolean('ENABLE_B2B_PARTNER_INTEGRATION', false, 'anonymous');

  const isVendorOrder = Boolean(data?.vendor_partnership_id);

  return (
    <div className="detail-order-with-driver">
      <div className="detail-order-with-driver__back-btn" onClick={backHandler}>
        <LeftArrow />
        <p>Kembali</p>
      </div>
      <TableWrapper
        icon={<WithDriverIcon fill="#009EF7" width="25px" height="25px" />}
        title="Dengan Supir"
        showExportButton
        onExportToPdf={handleExportToPdf}
        CustomFilterComponent={
          Object.prototype.hasOwnProperty.call(data, 'order_approval_history') ? (
            <div className="btn-export">
              <Button variant="primary" onClick={() => setShowPriceDifference(true)}>
                Detail Perbedaan
              </Button>
            </div>
          ) : null
        }
      >
        {data?.order_approval_status?.includes('UPDATE_ORDER') ? (
          <Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
            <TabPane label="Data Sekarang">
              <DetailPenyewa
                data={newOrderData}
                customer={customer}
                selectedCountry={selectedCountry}
                getFileName={getFileName}
                imagePreviewHandler={imagePreviewHandler}
                approvalUpdate
              />

              <DetailPemesanan data={newOrderData} selectedCountry={selectedCountry} />

              <DetailSewa data={newOrderData} vehicleById={newOrderData?.order_detail?.vehicle} />

              <div className="detail-order-with-driver__rent-zone">
                <div className="detail-order-with-driver__rent-detail-title">
                  <h1>Zona Penyewaan</h1>
                </div>
                <BookingZone
                  startDate={new Date(newOrderData?.order_detail?.start_booking_date)}
                  durationRentDate={newOrderData.order_detail?.booking_zones?.length}
                  selectedCar={newOrderData?.order_detail?.vehicle}
                  orderData={{ order_detail: { booking_zones: newOrderData?.order_detail?.booking_zones } }}
                  isOrderConfirmation={true}
                  forCustomOrder={false}
                  rentalLocation={rentalLocation}
                />
              </div>

              <div className="detail-order-with-driver__price-detail-body__input-violation">
                <InputViolation
                  violationList={[]}
                  setViolationList={setViolationList}
                  totalPrice={newOrderData?.order_violations
                    ?.map((item) => item.cost)
                    ?.reduce((acc, cVal) => acc + cVal, 0)}
                  violationPrice={0}
                  data={newOrderData?.order_violations || []}
                  isOnEdit={false}
                />
              </div>
              <div className="detail-order-with-driver__price-detail-body__input-additional">
                <InputAdditionals
                  additionalList={[]}
                  setAdditionalList={setAdditionalList}
                  totalPrice={newOrderData?.order_additional_fees
                    ?.map((item) => item.value)
                    ?.reduce((acc, cVal) => acc + cVal, 0)}
                  additionalPrice={0}
                  data={newOrderData?.order_additional_fees || []}
                  isOnEdit={false}
                />
              </div>

              <DetailDeposit customerAccountBank={customerAccountBank} />
              <AddOnsField data={newOrderData?.addons} totalPrice={newOrderData?.addon_total_price} />
              <RincianBiaya data={newOrderData} isApproval={true} />
              <DetailVoucher data={newOrderData} />
              <Pembayaran
                data={data}
                getFileName={getFileName}
                customer={customer}
                imagePreviewHandler={imagePreviewHandler}
                isPaymentValid={isPaymentValid}
                setShowBankTransferConfirmation={setShowBankTransferConfirmation}
              />

              <div className="detail-order-with-driver__transaction-buttons">
                <Button variant="outline" className="button" width={208} size="sm" onClick={backHandler}>
                  Kembali
                </Button>

                <RenderedProcessButton
                  data={data}
                  paymentMethod={paymentMethod}
                  customer={customer}
                  isPaymentValid={isPaymentValid}
                  handleProcess={handleProcess}
                />
              </div>
            </TabPane>
            <TabPane label="Data Sebelum">
              <DetailPenyewa
                data={oldOrderData}
                customer={customer}
                selectedCountry={selectedCountry}
                getFileName={getFileName}
                imagePreviewHandler={imagePreviewHandler}
                approvalUpdate
              />

              <DetailPemesanan data={oldOrderData} selectedCountry={selectedCountry} />

              <DetailSewa data={oldOrderData} vehicleById={oldOrderData?.order_detail?.vehicle} />

              <div className="detail-order-with-driver__rent-zone">
                <div className="detail-order-with-driver__rent-detail-title">
                  <h1>Zona Penyewaan</h1>
                </div>
                <BookingZone
                  startDate={new Date(oldOrderData?.order_detail?.start_booking_date)}
                  durationRentDate={oldOrderData?.order_detail?.booking_zones?.length}
                  selectedCar={oldOrderData?.order_detail?.vehicle}
                  orderData={{ order_detail: { booking_zones: oldOrderData?.order_detail?.booking_zones } }}
                  isOrderConfirmation={true}
                  forCustomOrder={false}
                  rentalLocation={rentalLocation}
                />
              </div>

              <div className="detail-order-with-driver__price-detail-body__input-violation">
                <InputViolation
                  violationList={[]}
                  setViolationList={setViolationList}
                  totalPrice={oldOrderData?.order_violations
                    ?.map((item) => item.cost)
                    ?.reduce((acc, cVal) => acc + cVal, 0)}
                  violationPrice={0}
                  data={oldOrderData?.order_violations || []}
                  isOnEdit={false}
                />
              </div>
              <div className="detail-order-with-driver__price-detail-body__input-additional">
                <InputAdditionals
                  additionalList={[]}
                  setAdditionalList={setAdditionalList}
                  totalPrice={oldOrderData?.order_additional_fees
                    ?.map((item) => item.value)
                    ?.reduce((acc, cVal) => acc + cVal, 0)}
                  additionalPrice={0}
                  data={oldOrderData?.order_additional_fees || []}
                  isOnEdit={false}
                />
              </div>

              <DetailDeposit customerAccountBank={customerAccountBank} />
              <AddOnsField
                data={oldOrderData?.addons?.length > 0 ? oldOrderData?.addons : addOnsOrder}
                totalPrice={oldOrderData?.addon_total_price}
              />
              <RincianBiaya data={oldOrderData} isApproval={true} />
              <DetailVoucher data={oldOrderData} />

              <div className="detail-order__payment-detail">
                <div className="detail-order__payment-detail-title">
                  <h1>Pembayaran</h1>
                </div>
                <div className="detail-order__payment-detail-body">
                  <InputField label="Status Pembayaran" disabled value={data?.order_status || '-'} />

                  <div
                    className={clsx(
                      'detail-order__payment-detail-body__payment-method',
                      data?.order_status === 'CHECKOUT' ? 'confirmation' : 'not-confirmation',
                    )}
                  >
                    <InputField label="Metode Pembayaran" disabled value={getPaymentMethodString(data.disbursement)} />
                  </div>

                  {data?.order_status !== 'CHECKOUT' &&
                  data?.order_status !== 'RECONFIRMATION' &&
                  Object.prototype.hasOwnProperty.call(data, 'disbursement') ? (
                    <>
                      <InputField
                        label="Nama Rekening"
                        disabled
                        value={
                          Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                            ? [...data.disbursement_reconfirmation].pop()?.sender_name
                            : data?.disbursement?.sender_name || '-'
                        }
                      />

                      <InputField
                        label="Nama Bank"
                        disabled
                        value={
                          Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                            ? [...data.disbursement_reconfirmation].pop()?.sender_bank_name
                            : data?.disbursement?.sender_bank_name || '-'
                        }
                      />

                      <div className="detail-order__payment-detail-body__preview-image">
                        <InputField
                          label="Foto Bukti Transfer"
                          disabled
                          value={getFileName(
                            Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                              ? [...data.disbursement_reconfirmation].pop()?.reconfirmation_image
                              : data?.disbursement.disbursement_confirmation_image,
                          )}
                          className="preview-image-input"
                        />

                        <Button
                          bgColor="#D9D9D9"
                          textColor="#000000"
                          className="preview-image-btn"
                          onClick={() =>
                            imagePreviewHandler(
                              Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                                ? [...data.disbursement_reconfirmation].pop()?.reconfirmation_image
                                : data?.disbursement.disbursement_confirmation_image,
                            )
                          }
                        >
                          Lihat
                        </Button>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>

              <div className="detail-order-with-driver__transaction-buttons">
                <Button variant="outline" className="button" width={208} size="sm" onClick={backHandler}>
                  Kembali
                </Button>
              </div>
            </TabPane>
          </Tabs>
        ) : (
          <>
            {isB2BPartnerIntegrationEnabled && isVendorOrder ? (
              <DetailPartner data={data} selectedCountry={selectedCountry} />
            ) : null}
            <DetailPenyewa
              data={data}
              customer={customer}
              selectedCountry={selectedCountry}
              getFileName={getFileName}
              imagePreviewHandler={imagePreviewHandler}
            />

            <DetailPemesanan data={data} selectedCountry={selectedCountry} />

            <DetailSewa data={data} vehicleById={data?.order_detail?.vehicle} />

            <div className="detail-order-with-driver__rent-zone">
              <div className="detail-order-with-driver__rent-detail-title">
                <h1>Zona Penyewaan</h1>
              </div>
              <BookingZone
                startDate={new Date(data?.order_detail?.start_booking_date)}
                durationRentDate={data?.order_detail?.booking_zones?.length}
                selectedCar={data?.order_detail?.vehicle}
                orderData={{ order_detail: { booking_zones: data?.order_detail?.booking_zones } }}
                isOrderConfirmation={true}
                forCustomOrder={false}
                rentalLocation={rentalLocation}
              />
            </div>

            <div className="detail-order-with-driver__price-detail-body__input-violation">
              <InputViolation
                violationList={[]}
                setViolationList={setViolationList}
                totalPrice={
                  data?.order_violations?.map((item) => item.cost)?.reduce((acc, cVal) => acc + cVal, 0) ||
                  violationPrice
                }
                violationPrice={0}
                data={data?.order_violations || []}
                isOnEdit={false}
              />
            </div>
            <div className="detail-order-with-driver__price-detail-body__input-additional">
              <InputAdditionals
                additionalList={[]}
                setAdditionalList={setAdditionalList}
                totalPrice={
                  data?.order_additional_fees?.map((item) => item.value)?.reduce((acc, cVal) => acc + cVal, 0) ||
                  additionalPrice
                }
                additionalPrice={0}
                data={data?.order_additional_fees || []}
                isOnEdit={false}
              />
            </div>

            <DetailDeposit customerAccountBank={customerAccountBank} isVendorOrder={isVendorOrder} />
            <AddOnsField data={addOnsOrder} totalPrice={data?.addon_total_price} />
            <RincianBiaya data={data} />
            <DetailVoucher data={data} />
            <Pembayaran
              data={data}
              getFileName={getFileName}
              customer={customer}
              imagePreviewHandler={imagePreviewHandler}
              isPaymentValid={isPaymentValid}
              setShowBankTransferConfirmation={setShowBankTransferConfirmation}
            />

            {review.length > 0 && data.order_status === 'FINISHED' && (
              <div className="detail-order__review">
                <div className="detail-order__review-title">
                  <h1>Review dan Penilaian</h1>
                </div>

                <div className="detail-order__review-body">
                  <h2 className="detail-order__review-order-key">{data.order_key}</h2>

                  <div className="detail-order__review-car-info-wrapper">
                    <div className="image-container">
                      <img src={IMAGE_BASE_URL + data?.order_detail?.vehicle?.photo[0].name} alt="" />
                    </div>

                    <div className="car-info">
                      <h3 className="car-name">{data?.order_detail?.vehicle.name}</h3>

                      <div className="car-attribute">
                        <p>{data?.order_detail?.vehicle.max_passanger} Seats</p>
                        <span>&#x2022;</span>
                        <p>{data?.order_detail?.vehicle.max_suitcase} Koper</p>
                        <span>&#x2022;</span>
                        <p>Transmisi {data?.order_detail?.vehicle.transmission}</p>
                      </div>

                      <div className="rating-wrapper">
                        {Array(5)
                          .fill(0)
                          .map((_, index) => {
                            return <Star key={index} color={review[0].rating > index ? '#f1a33a' : '#a9a9a9'} />;
                          })}
                      </div>
                    </div>
                  </div>

                  {review[0].comment ? (
                    <div className="user-comment-wrapper">
                      <textarea
                        name="user-comment"
                        id=""
                        cols="30"
                        rows="10"
                        value={review[0].comment}
                        readOnly
                        disabled
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            )}

            <ActionButtons
              data={data}
              backHandler={backHandler}
              RenderedProcessButton={RenderedProcessButton}
              isPaymentValid={isPaymentValid}
              handleProcess={handleProcess}
            />
          </>
        )}
      </TableWrapper>
      {showPriceDifference &&
        ReactDOM.createPortal(
          <PriceDifferenceModal
            setShowPriceDifference={setShowPriceDifference}
            Icon={WithDriverIcon}
            title="Dengan Supir"
            data={data}
          />,
          document.getElementById('modal'),
        )}
    </div>
  );
};

export default DetailOrder;
